import Icon from '@material-ui/core/Icon';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

import { useObservable } from '~/@components/@hooks/use-observable';
import { COLORS } from '~/@components/@theme/colors';
import { Chip } from '~/@components/Chip';
import { BlacklistItemField, blacklistStore } from '~/@store/blacklist';
import { removeEmptyKeys } from '~/@store/common';
import { formatFilterValue } from '~/@views/AdminView/common/utils';
import i18n from '~/i18n';

import { isNullOrUndefined } from '../../../../../../common/validations/types.validation';

const FieldNames: Record<BlacklistItemField, string> = {
    [BlacklistItemField.email]: i18n.BlacklistPage.email,
};

export const BlacklistFilterSummary = () => {
    const filterValues = useObservable(() => removeEmptyKeys({ ...blacklistStore.filter.values }));
    const { root, chip } = useStyles();

    return (
        <div className={root}>
            {Object.keys(filterValues).map(objectKey => {
                const key = objectKey as BlacklistItemField;
                const value = filterValues[key];
                if (isNullOrUndefined(value)) return null;

                const chipContent = `${FieldNames[key]}: "${formatFilterValue(value)}"`;

                return (
                    <Chip
                        key={key}
                        className={chip}
                        color={COLORS.black}
                        onDelete={() => blacklistStore.filter.setValue(key, null)}
                        deleteIcon={<Icon>close</Icon>}>
                        {chipContent}
                    </Chip>
                );
            })}
        </div>
    );
};

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        display: 'flex',
        alignItems: 'center',
    },
    chip: {
        marginRight: theme.spacing(1),
    },
}));
